/** Visibility for balance cards, using the viewed employee's API profile. */
export const isLeaveBalanceVisible = (
  leaveName: string,
  gender?: string | null,
  maritalStatus?: string | null,
): boolean => {
  const normalize = (value?: string | null) => value?.trim().toLowerCase().replace(/[^a-z]/g, "") ?? "";
  const name = normalize(leaveName);
  const status = normalize(maritalStatus);
  if (["sabbatical", "leavewithoutpay", "religiousleave"].includes(name)) return false;
  if (name === "paternityleave") return status === "married" && normalize(gender) === "male";
  if (name === "maternityleave") return status === "married" && normalize(gender) === "female";
  if (name === "wedding") return ["single", "unmarried"].includes(status);
  return true;
};
